/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { FuelSurchargeValueDTO, ShipmentBundle } from "../models/index";
import {
  FuelSurchargeValueDTOFromJSON,
  FuelSurchargeValueDTOToJSON,
  ShipmentBundleFromJSON,
  ShipmentBundleToJSON,
} from "../models/index";

export interface SyncShipmentRequest {
  shipmentId: string;
}

/**
 *
 */
export class EnvironmentSyncApi extends runtime.BaseAPI {
  /**
   */
  async syncFuelSurchargeValuesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<FuelSurchargeValueDTO>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/environment-sync/sync-fuel-surcharge-values`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(FuelSurchargeValueDTOFromJSON),
    );
  }

  /**
   */
  async syncFuelSurchargeValues(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<FuelSurchargeValueDTO>> {
    const response = await this.syncFuelSurchargeValuesRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async syncShipmentRaw(
    requestParameters: SyncShipmentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShipmentBundle>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling syncShipment().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/environment-sync/sync-shipment`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShipmentBundleFromJSON(jsonValue),
    );
  }

  /**
   */
  async syncShipment(
    requestParameters: SyncShipmentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShipmentBundle> {
    const response = await this.syncShipmentRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
